import { render } from "./AttachCourseMap.vue?vue&type=template&id=30b7f025"
import script from "./AttachCourseMap.vue?vue&type=script&lang=js"
export * from "./AttachCourseMap.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__